/* eslint-disable max-len */

import React from "react"
import BaseSvgIcon from "./Base"

const Person = (props) => {
  return (
    <BaseSvgIcon {...props}>
      <path
        d="m11.0321523 9.82383677c-.3979721-.13086285-.4682007-.66379068-.1177159-.89328432.9820383-.64302804 1.5855636-1.73502442 1.5855636-2.93055245 0-1.93299662-1.5670034-3.5-3.5-3.5-1.93299662 0-3.5 1.56700338-3.5 3.5 0 1.19552803.60352525 2.28752441 1.58556363 2.93055245.35048481.22949364.2802562.76242147-.11771597.89328432-2.48755509.81796803-4.24838114 3.05896953-4.44876389 5.67616323h12.96183243c-.2003827-2.6171937-1.9612088-4.8581952-4.4487639-5.67616323zm-6.5321523-3.82383677c0-2.48528137 2.01471863-4.5 4.5-4.5 2.4852814 0 4.5 2.01471863 4.5 4.5 0 1.22562024-.4941006 2.36754064-1.3342897 3.1986206 2.6017407 1.2108691 4.3342897 3.8394698 4.3342897 6.8013794 0 .2761424-.2238576.5-.5.5h-14c-.27614237 0-.5-.2238576-.5-.5 0-2.9619096 1.73254903-5.5905103 4.33428968-6.8013794-.84018909-.83107996-1.33428968-1.97300036-1.33428968-3.1986206z"
        fill="#3d3d36"
      />
    </BaseSvgIcon>
  )
}

export default Person
